import { fromJS, Map } from 'immutable';

import { setOutageData } from './actions';

export const defaultState = Map({
  outage: null
});

export default function outages(state = defaultState, action) {
  const newState = fromJS(state);

  switch (action.type) {
    case setOutageData.type:
      return newState.set('outage', action.payload);

    default:
      return newState;
  }
}

export const outage = state => state.outages.get('outage');
